angular.module('impactx.basket').controller('BasketAttributesOnRepeatCtrl', BasketAttributesOnRepeatCtrl);

BasketAttributesOnRepeatCtrl.$inject = ['$scope', 'dataGen', 'TranslationService', '$mdDialog', 'bkiId', 'themeFactory'];

function BasketAttributesOnRepeatCtrl($scope, dataGen, TranslationService, $mdDialog, bkiId, themeFactory) {
    $scope.theme = themeFactory.getTheme();
    var ctrl = this;
    $scope.errorList = [];

    ctrl.getData = function () {
        var paramObj = {
            bkiId: bkiId
        };
        dataGen.getData($scope, paramObj, '/basket/variableattributes/onrepeat/get').then(function () {
            $scope.trns.save = TranslationService.get('save');
            $scope.trns.required = TranslationService.get('required');
        })
    };

    ctrl.saveAttributes = function () {
        var paramObj = {
            attributesData: $scope.data
        };
        dataGen.postAsForm({}, paramObj, '/basket/variableattributes/onrepeat/save').then(function () {
            $mdDialog.hide();
        });
    };

    ctrl.getData();
}